/* tslint:disable:member-ordering */

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Store } from '@ngrx/store';
import { StorageAction } from './storage.action';
import { StorageService } from '../../services/storage/storage.service';
import { exhaustMap } from 'rxjs/operators';

@Injectable()
export class StorageEffects {

    constructor(
        private store: Store<any>,
        private actions$: Actions,
        private storageService: StorageService,
    ) { }

    /**
     * Adiciona um cookie no browser refletindo o mesmo na Store
     */
    setCookieItem$ = createEffect(() => this.actions$
        .pipe(
          ofType(StorageAction.setCookieItem),
          exhaustMap((action: any) => {
            this.storageService.cookie.setItem(
                action.payload.key,
                action.payload.data,
                action.payload.expiresIn,
                action.payload.domain,
                action.payload.path,
            );

            return this.storeEvent('cookie', action.payload);
        })));

    /**
     * Remove um cookie do browser refletindo o mesmo na Store
     */
    removeCookieItem$ = createEffect(() => this.actions$
        .pipe(
          ofType(StorageAction.removeCookieItem),
          exhaustMap((action: any) => {
            this.storageService.cookie.removeItem(action.payload.key);
            return this.unstoreEvent('cookie', action.payload);
        })));

    /**
     * Adiciona um item no localStorage refletindo o mesmo na Store
     */
    setLocalItem$ = createEffect(() => this.actions$
        .pipe(
          ofType(StorageAction.setLocalItem),
          exhaustMap((action: any) => {
            this.storageService.local.setItem(action.payload.key, action.payload.data);
            return this.storeEvent('local', action.payload);
        })));

    /**
     * Remove um item do localStorage refletindo o mesmo na Store
     */
    removeLocalItem$ = createEffect(() => this.actions$
        .pipe(
          ofType(StorageAction.removeLocalItem),
          exhaustMap((action: any) => {
            this.storageService.local.removeItem(action.payload.key);
            return this.unstoreEvent('local', action.payload);
        })));

    /**
     * Adiciona um item no sessionStorage refletindo o mesmo na Store
     */
    setSessionItem$ = createEffect(() => this.actions$
        .pipe(
          ofType(StorageAction.setSessionItem),
          exhaustMap((action: any) => {
            this.storageService.session.setItem(action.payload.key, action.payload.data);
            return this.storeEvent('session', action.payload);
        })));

    /**
     * Remove um item do sessionStorage refletindo o mesmo na Store
     */
    removeSessionItem$ = createEffect(() => this.actions$
        .pipe(
          ofType(StorageAction.removeSessionItem),
          exhaustMap((action: any) => {
            this.storageService.session.removeItem(action.payload.key);
            return this.unstoreEvent('session', action.payload);
        })));

    /**
     * Retorna um Observable do evento que salva um item no StorageReducer
     *
     * @param  {} storageType
     * @param  {} payload
     */
    public storeEvent = (storageType, payload) => of({
        type: StorageAction.storeItem,
        payload: {
            storageType,
            ...payload,
        },
    })

    /**
     * Retorna um Observable do evento que remove um item no StorageReducer
     *
     * @param  {} storageType
     * @param  {} payload
     */
    public unstoreEvent = (storageType, payload) => of({
        type: StorageAction.unstoreItem,
        payload: {
            storageType,
            ...payload,
        },
    })
}
